import React from 'react';
import {BLOCKS, MARKS, INLINES} from '@contentful/rich-text-types';
import Copy, {Bold, Italic} from '@nib-components/copy';
import Link from '@nib-components/link';

// Options for rendering rich text coming from Contentful

/* eslint-disable */
const options = {
  renderMark: {
    [MARKS.BOLD]: text => <Bold>{text}</Bold>,
    [MARKS.ITALIC]: text => <Italic>{text}</Italic>
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Copy measure={false}>{children}</Copy>,
    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri} target="_blank">
        {children}
      </Link>
    )
  }
};
/* eslint-enable */

export default options;
